<template>
    <div>
        <my-search
            timeScreen
            :order="1"
            :searchParams="searchParams"
            :selectArr="selectArr"
            :inputArr="inputArr"
            @searchEvent="searchEvent"
        />
        <!-- 表格展示查询的数据  -->
        <myTable
            :loading="loading"
            :tableData="tableData"
            :tableHeader="tableHeader"
        />
        <!-- 分页器 -->
        <my-pagination :childMsg="pageParams" @callFather="callFather" />
    </div>
</template>

<script>
import { foreEndLogList } from "@/network/system/log.js";
import mixins from "@/mixins/common";
export default {
    name: "frontEndLog",
    mixins: [mixins],
    data() {
        return {
            tableHeader: Object.freeze([
                {
                    name: "设备id",
                    prop: "deviceId",
                },
                {
                    name: "用户id",
                    prop: "userId",
                },
                {
                    name: "日志等级",
                    prop: "logLevel",
                },
                {
                    name: "日志类型",
                    prop: "logType",
                },
                {
                    name: "请求接口",
                    prop: "interfaceUrl",
                },
                {
                    name: "内容",
                    prop: "content",
                },
                {
                    name: "操作行为",
                    prop: "clickFunction",
                },
                {
                    name: "发生时间",
                    prop: "requestTime",
                },
            ]),
            selectArr: [
                {
                    defaultText: "请选择日志等级",
                    name: "logLevel",
                    getData: "label",
                    defaultOptions: [
                        { label: "DEBUG" },
                        { label: "INFO" },
                        { label: "WARN" },
                        { label: "ERROR" },
                        { label: "FATAL" },
                        { label: "ALL" },
                    ],
                },
            ],
            inputArr: [
                {
                    name: "deviceId",
                    defaultText: "请输入设备id",
                },
            ],
            searchParams: { logLevel: "", deviceId: "", timeOptions: [] },
        };
    },
    created() {
        this.getInitData();
    },
    methods: {
        getInitData(currentPage = this.pageParams.currentPage) {
            let { timeOptions, logLevel, deviceId } = this.searchParams;
            let params = {
                data: {
                    logLevel,
                    deviceId,
                    startTime: timeOptions ? timeOptions[0] : undefined,
                    endTime: timeOptions ? timeOptions[1] : undefined,
                },
                current: currentPage,
                size: this.pageParams.pageSize,
            };
            foreEndLogList(params).then((e) => {
                this.loading = true;
                let { code, data } = e.data;
                if (code == 200) {
                    this.loading = false;
                    this.tableData = data.records;
                    this.pageParams.total = data.total;
                    // this.pageParams.currentPage = currentPage;
                }
            });
        },
        // 搜索
        searchEvent() {
            this.getInitData(1);
        },
    },
};
</script>

<style scoped>
</style>

 
 